import React, { useEffect, useCallback } from "react";
import { getBasicUserDetailsById } from "../../../../setup/api/services/user";
import { ImageTitleAndDescrComp } from "./imageTitleAndDesc";
import Avatar, { AvatarSize } from "../../../../components/common/Avatar";

import styles from "./styles.module.scss";
import UserBankInfoModal from "../bankInfoModal";
import { BANK_INFO } from "../constants";
import { ECONTRACT_STATUS } from "../../../../enums";
import { IUserInfoResponse } from "../../../../setup/api/services/user/models";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../../setup/constants";

export const UserInfo = (props: any) => {
  const navigate = useNavigate();
  const [user, setUser] = React.useState<any>();
  const [openModal, setOpenModal] = React.useState<any>(false);
  const [profileUrl, setProfileUrl] = React.useState("");
  const renderUserId = props.renderUserId;
  const { contractStatus, type } = props;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchUserBasicInfo = useCallback(async () => {
    const response: IUserInfoResponse = await getBasicUserDetailsById(
      renderUserId
    );
    setUser(response.data);
    setProfileUrl(
      response.data.profile.photoUrl
        ? response.data.profile.photoUrl
        : "../../../assets/images/user.png"
    );
  }, [renderUserId]);

  useEffect(() => {
    fetchUserBasicInfo().catch(console.error);
  }, [fetchUserBasicInfo]);

  const showUserProfile = useCallback(() => {
    navigate(`${ROUTES.STAT_USER}${renderUserId}`);
  }, [navigate, renderUserId]);

  const imageNode = useCallback(() => {
    return (
      <a onClick={showUserProfile}>
        <Avatar alt={"user"} src={profileUrl} avatarSize={AvatarSize.MEDIUM} />
      </a>
    );
  }, [profileUrl, showUserProfile]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const bankInfoLink = (userType: string) =>
    userType == type && (
      <>
        <div
          className={styles.account}
          onClick={(e) => {
            e.stopPropagation();
            setOpenModal(!openModal);
          }}>
          {BANK_INFO}
        </div>
        <UserBankInfoModal
          showModal={openModal}
          userId={user?.id}
          closeModal={(e) => {
            e.stopPropagation();
            setOpenModal(!openModal);
          }}
        />
      </>
    );

  const checkViewBankInfo = useCallback(() => {
    switch (contractStatus) {
      case ECONTRACT_STATUS.ITEM_ACCEPTED:
        return bankInfoLink("sender");
      case ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER:
        return bankInfoLink("receiver");
      case ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER:
        return bankInfoLink("sender");
      default:
        return <></>;
    }
  }, [bankInfoLink, contractStatus]);

  const titleNode = useCallback(() => {
    return (
      <div className={styles.title_wrapper}>
        <p className={styles["subtitle3"]}>{user?.profile?.fullName}</p>

        {checkViewBankInfo()}
      </div>
    );
  }, [checkViewBankInfo, user?.profile?.fullName]);
  const phoneNumberValueNode = () => {
    return (
      <div
        onClick={showUserProfile}
        dir="ltr"
        style={{ textAlign: "right" }}
        className={styles["p2"]}>
        {user?.phoneNumber}
      </div>
    );
  };

  return (
    <ImageTitleAndDescrComp
      image={imageNode()}
      title={titleNode()}
      value={phoneNumberValueNode()}
    />
  );
};
